document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-kc-blog-slider]').forEach(function (slider) {
    const track = slider.querySelector('[data-kc-blog-slider-track]');
    const prev = slider.querySelector('[data-kc-blog-slider-prev]');
    const next = slider.querySelector('[data-kc-blog-slider-next]');

    if (!track || !prev || !next) return;

    function getScrollAmount() {
      return track.clientWidth * 0.85;
    }

    function updateArrows() {
      const maxScrollLeft = track.scrollWidth - track.clientWidth;
      const currentScroll = track.scrollLeft;

      prev.disabled = currentScroll <= 5;
      next.disabled = currentScroll >= maxScrollLeft - 5;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    next.addEventListener('click', function () {
      track.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });
});